// api.ts
import { ApiEndpoints } from "@shared/api/api-endpoints";
import { bxApiClient, receiptApiClient } from "@shared/api/clients/apiClientFactory";
import { getRemoteUtilityId } from "@shared/utils/getUtilityId";
import { SaveCanvasTemplatePayload } from "./types";
import { QueryStringParameters } from "@shared/api/url-builder";

export const getCanvasTemplate = async (templateId?: string) => {
  const path = templateId 
    ? `base-template-configuration/${templateId}` 
    : "base-template-configuration";
  
  const url = ApiEndpoints.createUrlWithQueryParameters("receipt", path);
  const response = await receiptApiClient.get(url);
  return response.data;
};

// this is used to fetch list of components available for the canvas template for dropdown section
export const getTemplateOptions = async (): Promise<any> => {
  const REMOTE_UTILITY_ID = getRemoteUtilityId();
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `fetch-base-templates`,
    (qs: QueryStringParameters) => {
      qs.push("remote_utility_id", REMOTE_UTILITY_ID.toLocaleString());
    }
  );
  const response = await bxApiClient.get(url);
  return response.data;
};

export const saveCanvasTemplate = async (payload: SaveCanvasTemplatePayload) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    "template-configuration"
  );
  const response = await receiptApiClient.post(url, payload);
  return response.data?.result;
};

export const updateCanvasTemplate = async (
  id: string, 
  payload: Partial<SaveCanvasTemplatePayload>
) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`
  );
  const response = await receiptApiClient.put(url, payload);
  return response.data?.result;
};

export const getConfiguredTemplate = async (id: string) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration/${id}`
  );
  const response = await receiptApiClient.get(url);
  return response.data?.result;
};

export const getCanvasTemplateDetail  = async (id: string) => {
  const url = ApiEndpoints.createUrlWithQueryParameters(
    "receipt",
    `template-configuration-detail/${id}`
  );
  const response = await receiptApiClient.get(url);
  return response.data?.result;
}